import { handleActions } from "redux-actions";
import { combineReducers } from "redux";
import {
  restoreLoginSuccess,
  restoreLoginFailure
} from "../actions/RestoreLogin";
import { resetLoginSuccess } from "../actions/RestoreLogin";
import { login } from "../actions/Login";
import {
  checkCode,
  checkCodeFailure,
  checkCodeSuccess
} from "../actions/CheckCode";
import {
  getUserSuccess,
  authUpdateProfileInfo
} from "../actions/GetUser/getUserActions";
import { updateUserAction } from "../actions/GetUser/updateUserActions";

const isAuthorized = handleActions(
  {
    [checkCodeSuccess]: (state, action) => {
      const { payload } = action;
      return !!payload.accessToken;
    },
    [restoreLoginSuccess]: (state, action) => {
      const { payload } = action;
      return !!payload.hasTokenExpired;
    },
    [restoreLoginFailure]: () => false,
    [resetLoginSuccess]: () => false
  },
  false
);
const isLogged = handleActions(
  {
    [getUserSuccess]: (state, action) => {
      const { payload } = action;
      if (!!(payload.name && payload.lastname)) {
        return true;
      } else {
        return state;
      }
    },
    [checkCodeSuccess]: (state, action) => {
      const { payload } = action;
      const { user } = payload;
      if (!!(user.name && user.lastname)) {
        return true;
      } else {
        return state;
      }
    }
  },
  false
);
const code = handleActions(
  {
    [checkCode]: (state, action) => {
      return { ...state, loading: true };
    },
    [checkCodeSuccess]: (state, action) => {
      return { ...state, loading: false, result: true };
    },
    [checkCodeFailure]: (state, action) => {
      return {
        ...state,
        loading: false,
        errorMsg:
          action.payload &&
          action.payload.response &&
          action.payload.response.data &&
          action.payload.response.data.message
      };
    }
  },
  {
    loading: false,
    result: false,
    errorMsg: false
  }
);
const phone = handleActions(
  {
    [login]: (state, action) => action.payload.phone,
    [restoreLoginSuccess]: (state, action) => action.payload.phone
  },
  null
);
const photo = handleActions(
  {
    [login]: (state, action) => action.payload.photo,
    [getUserSuccess]: (state, action) => {
      return action.payload.photo;
    }
  },
  null
);

const info = handleActions(
  {
    [getUserSuccess]: (state, action) => {
      return action.payload;
    },
    [checkCodeSuccess]: (state, action) => action.payload.user,
    [authUpdateProfileInfo]: (state, action) => ({
      ...state,
      ...action.payload
    }),
    [updateUserAction]: (state, action) => action.payload
  },
  null
);
const id = handleActions(
  {
    [checkCodeSuccess]: (state, action) => action.payload.user.userId,
    [restoreLoginSuccess]: (state, action) => action.payload.id
  },
  null
);
const user = combineReducers({
  isAuthorized,
  isLogged,
  phone,
  photo,
  info,
  id,
  code
});

export { user };
